import { postRequest } from "../libs/AxiosService.util";

export async function serviceFeedbackList(params) {
  return await postRequest("feedback", params);
}

export async function serviceFeedbackDetail(params) {
  return await postRequest("feedback/detail", params);
}

export async function serviceFeedbackResendMessage(params) {
  return await postRequest("feedback/resend/message", params);
}

export async function serviceFeedbackCustomerDetail(params) {
  return await postRequest("feedback/customer/detail", params);
}

export async function serviceFeedbackCustomerSubmit(params) {
  return await postRequest("feedback/customer/submit", params);
}

